export default __webpack_public_path__ + "static/media/franchises-icon2.3628ab15.svg";